import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'

import DrillDownFilter from '~/client/src/shared/components/DrillDownFilter'
import { useFullscreenElement } from '~/client/src/shared/utils/fullscreenElement'
import { HostPortalContainerContext } from '~/client/src/shared/utils/hostPortalContainer'

import { ListHeaderFilterButton } from './ListHeaderFilterButton'

interface IProps {
  badgeCount?: number
  // A DrillDownFilter.Platform body; it closes the surface through the shell.
  children: React.ReactNode
}

export function ListHeaderFilter({
  badgeCount,
  children,
}: IProps): React.ReactElement {
  const { isMobileEnv } = React.useContext(MobXProviderContext) as {
    isMobileEnv?: boolean
  }
  // A body portal renders outside a fullscreen subtree (the map), hence invisible.
  const fullscreenElement = useFullscreenElement() as HTMLElement | null
  const hostPortalContainer = React.useContext(HostPortalContainerContext)
  const [open, setOpen] = React.useState(false)

  if (isMobileEnv) {
    return (
      <>
        <ListHeaderFilterButton
          badgeCount={badgeCount}
          aria-haspopup="dialog"
          aria-expanded={open}
          onClick={() => setOpen(true)}
        />
        <DrillDownFilter.Drawer open={open} onOpenChange={setOpen} noBodyStyles>
          {children}
        </DrillDownFilter.Drawer>
      </>
    )
  }

  return (
    <DrillDownFilter.Popover
      open={open}
      onOpenChange={setOpen}
      align="end"
      portalContainer={fullscreenElement ?? hostPortalContainer}
      trigger={<ListHeaderFilterButton badgeCount={badgeCount} />}
    >
      {children}
    </DrillDownFilter.Popover>
  )
}
